import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { hubIndexHead } from "@/lib/hub-seo";

const PATH = "/fi/pubs";

export const Route = createFileRoute("/fi/pubs/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("pubs")),
  head: ({ loaderData }) =>
    hubIndexHead({
      path: PATH,
      locale: "fi",
      loaderData,
      fallbackTitle: 'Pubit Suomessa — olutkapakat ja kulmapubit | what Finland',
      fallbackDescription: 'Suomalaiset pubit ja olutkapakat alueittain, aukioloaikoineen.',
      listName: 'Pubit Suomessa',
    }),
  component: () => <HubIndexPage slug="pubs" locale="fi" />,
});
